import { QuestionCircleOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import { useMount } from 'ahooks';
import { Tooltip, message } from 'antd';
import DecorateTitle from 'components/DecorateTitle';
import FacebookLangSelect from 'components/Langs/FacebookLangSelect';
import { RegionLangSelect } from 'components/Langs/RegionLangSelect';
import {
  useRegionLanguageMap,
  useSetRegionLanguageMap,
} from 'hooks/business/system/useRegionLanguage';
import { permissionNameIdMap } from 'hooks/business/useNewPermisson';
import { useState } from 'react';
import { getOrgRegions, getRegionsStoreCount, updateRegionLanguageMap } from 'services/api/admin';

export const TranslateLanguage = () => {
  const { t } = useTranslate();

  const [regionList, setRegionList] = useState<General.UpperCaseRegion[]>([]);
  const [hasFacebook, setHasFacebook] = useState(false);

  useMount(() => {
    getOrgRegions()
      .then(({ regions }) => setRegionList(regions))
      .catch(() => {});
    getRegionsStoreCount(permissionNameIdMap.基础聊天权限)
      .then((res) => setHasFacebook(Boolean(res.data.data.facebookCountData?.gbCnt)))
      .catch(() => {});
  });

  const regionLanguageMap = useRegionLanguageMap();
  const setRegionLanguageMap = useSetRegionLanguageMap();

  if (!regionList?.length) {
    return null;
  }

  const update = (region: General.UpperCaseRegion | 'FACEBOOK', lang: General.Language) => {
    const next = {
      ...regionLanguageMap,
      [region]: lang,
    };
    setRegionLanguageMap(next);
    updateRegionLanguageMap({ translationConfig: next }).catch(() => {
      message.error(t('phrase.保存失败，请稍后再试'));
    });
  };

  return (
    <>
      <DecorateTitle>
        {t('翻译语言设置')}
        <Tooltip title={t('默认翻译语言tips')}>
          <QuestionCircleOutlined />
        </Tooltip>
      </DecorateTitle>
      <List>
        {regionList.map((region) => {
          if (region === 'TW') {
            return null;
          }
          return (
            <li key={region}>
              <div>{t(`region.${region.toLowerCase()}`)}</div>
              <RegionLangSelect
                region={region}
                value={regionLanguageMap[region]}
                onChange={(lang) => update(region, lang)}
              />
            </li>
          );
        })}
        {hasFacebook && (
          <li>
            <div>Facebook</div>
            <FacebookLangSelect
              value={regionLanguageMap.FACEBOOK}
              onChange={(lang) => update('FACEBOOK', lang)}
            />
          </li>
        )}
      </List>
    </>
  );
};

const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  list-style: none;
  > li {
    flex: 0 0 auto;
    width: 33.33%;
    display: flex;
    flex-direction: column;
    margin-bottom: 18px;
    padding-right: 24px;
    > * {
      width: 100%;
    }
    > div {
      margin-bottom: 4px;
    }
    .ant-select {
      width: 100%;
    }
  }
`;
